import { connect } from 'react-redux';
import Home from './Home';


let mapStateToProps = (state) => {
  return {
    productsData: state.productsPage.productsData,
    aboutData: state.aboutPage.aboutData
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const HomeContainer = connect(mapStateToProps, mapDispatchToProps)(Home);

export default HomeContainer;